import { atom } from "recoil";

export const invalidTextareaIndexAtom = atom<string[]>({
  key: "invalidTextareaIndexAtom",
  default: [],
});